// extracted by mini-css-extract-plugin
export default {"container":"background_figures_container__27ksf","stripe":"background_figures_stripe__4xt+r"};